import React, { Dispatch, SetStateAction } from 'react';
import { css } from '@emotion/react';

interface IHamburgerProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const Hamburger = ({ open, setOpen }: IHamburgerProps) => {
  return (
    <div
      css={css`
        display: none;
        @media (max-width: 992px) {
          display: block;
        }
      `}
    >
      <div
        css={css`
          display: none;
          @media (max-width: 992px) {
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: 30px;
            height: 20px;
            border: none;
            cursor: pointer;
            z-index: 9000;
          }
          &:focus {
            outline: none;
          }
        `}
        onClick={() => setOpen(!open)}
      >
        <div
          css={css`
            width: 20px;
            height: 2px;
            border-radius: 15px;
            position: relative;
            transform-origin: 0.5px;
            background-color: #4c4c4c;
          `}
          style={{
            transform: open ? 'rotate(45deg)' : 'rotate(0)',
            top: open ? '3px' : '0',
          }}
        />
        <div
          css={css`
            width: 20px;
            height: 2px;
            border-radius: 15px;
            position: relative;
            transform-origin: 0.5px;
            background-color: #4c4c4c;
          `}
          style={{
            opacity: open ? '0' : '1',
            top: open ? '0' : '0',
          }}
        />
        <div
          css={css`
            width: 20px;
            height: 2px;
            border-radius: 15px;
            position: relative;
            transform-origin: 0.5px;
            background-color: #4c4c4c;
          `}
          style={{
            transform: open ? 'rotate(-45deg)' : 'rotate(0)',
            top: open ? '3px' : '0',
          }}
        />
      </div>
    </div>
  );
};
